function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_SCHOOL = '/school';
const ROOTS_CLASS = '/class';
const ROOTS_PARENT = '/parent';
const ROOTS_TEACHER = '/teacher';
const ROOTS_SUPPORT_TICKET = '/support-ticket';

// Factor6
const ROOTS_STUDENTS = '/students'

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};

export const PATH_PAGE = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
  },
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
};

export const PATH_SCHOOL = {
  root: ROOTS_SCHOOL,
  list: path(ROOTS_SCHOOL, '/list'),
  details: (id) => path(ROOTS_SCHOOL, `/${id}/details`),
};
export const PATH_STUDENT = {
  root: ROOTS_STUDENTS,
  list: path(ROOTS_STUDENTS, '/list'),
  details: (id) => path(ROOTS_STUDENTS, `/${id}/details`),
};

export const PATH_CLASS = {
  root: ROOTS_CLASS,
  list: path(ROOTS_CLASS, '/list'),
  details: (id) => path(ROOTS_CLASS, `/${id}/details`),
};

export const PATH_PARENT = {
  root: ROOTS_PARENT,
  list: path(ROOTS_PARENT, '/list'),
  details: (id) => path(ROOTS_PARENT, `/${id}/details`),
};

export const PATH_TEACHER = {
  root: ROOTS_TEACHER,
  list: path(ROOTS_TEACHER, '/list'),
  details: (id) => path(ROOTS_TEACHER, `/${id}/details`),
};

export const PATH_SUPPORT_TICKET = {
  root: ROOTS_SUPPORT_TICKET,
  list: path(ROOTS_SUPPORT_TICKET, '/list'),
  details: (id) => path(ROOTS_SUPPORT_TICKET, `/${id}/details`),
};
